import {
  PUT_ECONOMICNUMBERS_CATALOG,
  PUT_ECONOMICNUMBERS_CATALOG_SUCCESS,
  PUT_ECONOMICNUMBERS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putEconomicNumbersCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case PUT_ECONOMICNUMBERS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_ECONOMICNUMBERS_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_ECONOMICNUMBERS_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
